// fake react-router-v6 API sur une base de react-router-dom@5
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import {useEffect} from "react";

export const Navigate = ({ to, replace = false }) => {
    const history = useHistory();

    useEffect(() => {
        if(to===-1){
            history.goBack()
        }else{
            if (replace) {
                history.replace(to);
            } else {
                history.push(to);
            }
        }
    }, [to, replace, history]);

    return null; // ce composant ne rend rien
};

// useNavigate shim
export function useNavigate() {
    const history = useHistory();
    return (to, options = {}) => {

        if(to===-1){
            history.goBack()
        }else{
            if (options.replace) {
                history.replace(to);
            } else {
                history.push(to);
            }
        }
    };
}

// useNavigationType (fake, renvoie toujours PUSH)
export function useNavigationType() {
    return 'PUSH'; // ou garder null si tu ne veux pas simuler ça
}

// useRoutes: impossible à shimer (trop spécifique à V6)
export function useRoutes() {
    throw new Error('useRoutes is not supported in react-router-dom v5.');
}

// useOutlet: impossible aussi
export function useOutlet() {
    return null;
}

// useRouter (non standard, mais pratique)
export function useRouter() {
    const history = useHistory();
    const location = useLocation();
    const params = useParams();
    const match = useRouteMatch();
    return { history, location, params, match };
}
